import React, { createContext, useContext, useState } from 'react';
import Popup from '../components/Popup';
import styled from 'styled-components';

const PopupContext = createContext();

export const usePopup = () => useContext(PopupContext);

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;


export const PopupProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState(null);

  const openPopup = (content) => {
    setContent(content);
    setIsOpen(true);
  };
   const closePopup = () => {
    setContent(null);
    setIsOpen(false);
  };
  const getClosePopup = () => closePopup;
 

  const value = {
    isOpen,
    openPopup,
    closePopup: getClosePopup,
    content
  };

  return (
    <PopupContext.Provider value={value}>
              {children}
     {isOpen && (
        <Backdrop onClick={closePopup}>
          <Popup>
            {content}
          </Popup>
        </Backdrop>
      )}
    </PopupContext.Provider>
  );
};